export const color = {
    "mode": "analogic-complement",
    "count": "15",
    "colors": [
    {
    "hex": {
    "value": "#54D7CC",
    "clean": "54D7CC"
    },
    "rgb": {
    "fraction": {
    "r": 0.32941176470588235,
    "g": 0.8431372549019608,
    "b": 0.8
    },
    "r": 84,
    "g": 215,
    "b": 204,
    "value": "rgb(84, 215, 204)"
    },
    "hsl": {
    "fraction": {
    "h": 0.48600508905852424,
    "s": 0.6208530805687204,
    "l": 0.5862745098039216
    },
    "h": 175,
    "s": 62,
    "l": 59,
    "value": "hsl(175, 62%, 59%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.48600508905852424,
    "s": 0.6093023255813953,
    "v": 0.8431372549019608
    },
    "value": "hsv(175, 61%, 84%)",
    "h": 175,
    "s": 61,
    "v": 84
    },
    "name": {
    "value": "Sea Serpent",
    "closest_named_hex": "#4BC7CF",
    "exact_match_name": false,
    "distance": 814
    },
    "cmyk": {
    "fraction": {
    "c": 0.6093023255813954,
    "m": 0,
    "y": 0.05116279069767437,
    "k": 0.1568627450980392
    },
    "value": "cmyk(61, 0, 5, 16)",
    "c": 61,
    "m": 0,
    "y": 5,
    "k": 16
    },
    "XYZ": {
    "fraction": {
    "X": 0.581755294117647,
    "Y": 0.730804705882353,
    "Z": 0.8672596078431374
    },
    "value": "XYZ(58, 73, 87)",
    "X": 58,
    "Y": 73,
    "Z": 87
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=54D7CC",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=54D7CC"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=54D7CC"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#59DACF",
    "clean": "59DACF"
    },
    "rgb": {
    "fraction": {
    "r": 0.34901960784313724,
    "g": 0.8549019607843137,
    "b": 0.8117647058823529
    },
    "r": 89,
    "g": 218,
    "b": 207,
    "value": "rgb(89, 218, 207)"
    },
    "hsl": {
    "fraction": {
    "h": 0.48578811369509045,
    "s": 0.6354679802955665,
    "l": 0.6019607843137255
    },
    "h": 175,
    "s": 64,
    "l": 60,
    "value": "hsl(175, 64%, 60%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.48578811369509045,
    "s": 0.591743119266055,
    "v": 0.8549019607843137
    },
    "value": "hsv(175, 59%, 85%)",
    "h": 175,
    "s": 59,
    "v": 85
    },
    "name": {
    "value": "Viking",
    "closest_named_hex": "#64CCDB",
    "exact_match_name": false,
    "distance": 727
    },
    "cmyk": {
    "fraction": {
    "c": 0.591743119266055,
    "m": 0,
    "y": 0.05045871559633023,
    "k": 0.14509803921568631
    },
    "value": "cmyk(59, 0, 5, 15)",
    "c": 59,
    "m": 0,
    "y": 5,
    "k": 15
    },
    "XYZ": {
    "fraction": {
    "X": 0.596172156862745,
    "Y": 0.744236862745098,
    "Z": 0.8802227450980392
    },
    "value": "XYZ(60, 74, 88)",
    "X": 60,
    "Y": 74,
    "Z": 88
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=59DACF",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=59DACF"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=59DACF"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#5EDDD3",
    "clean": "5EDDD3"
    },
    "rgb": {
    "fraction": {
    "r": 0.3686274509803922,
    "g": 0.8666666666666667,
    "b": 0.8274509803921568
    },
    "r": 94,
    "g": 221,
    "b": 211,
    "value": "rgb(94, 221, 211)"
    },
    "hsl": {
    "fraction": {
    "h": 0.4868766404199475,
    "s": 0.6512820512820513,
    "l": 0.6176470588235294
    },
    "h": 175,
    "s": 65,
    "l": 62,
    "value": "hsl(175, 65%, 62%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.4868766404199475,
    "s": 0.5746606334841629,
    "v": 0.8666666666666667
    },
    "value": "hsv(175, 57%, 87%)",
    "h": 175,
    "s": 57,
    "v": 87
    },
    "name": {
    "value": "Viking",
    "closest_named_hex": "#64CCDB",
    "exact_match_name": false,
    "distance": 653
    },
    "cmyk": {
    "fraction": {
    "c": 0.5746606334841629,
    "m": 0,
    "y": 0.04524886877828064,
    "k": 0.1333333333333333
    },
    "value": "cmyk(57, 0, 5, 13)",
    "c": 57,
    "m": 0,
    "y": 5,
    "k": 13
    },
    "XYZ": {
    "fraction": {
    "X": 0.611296862745098,
    "Y": 0.757952156862745,
    "Z": 0.8969133333333333
    },
    "value": "XYZ(61, 76, 90)",
    "X": 61,
    "Y": 76,
    "Z": 90
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=5EDDD3",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=5EDDD3"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=5EDDD3"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#64E0D6",
    "clean": "64E0D6"
    },
    "rgb": {
    "fraction": {
    "r": 0.39215686274509803,
    "g": 0.8784313725490196,
    "b": 0.8392156862745098
    },
    "r": 100,
    "g": 224,
    "b": 214,
    "value": "rgb(100, 224, 214)"
    },
    "hsl": {
    "fraction": {
    "h": 0.48655913978494625,
    "s": 0.6666666666666666,
    "l": 0.6352941176470588
    },
    "h": 175,
    "s": 67,
    "l": 64,
    "value": "hsl(175, 67%, 64%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.48655913978494625,
    "s": 0.5535714285714286,
    "v": 0.8784313725490196
    },
    "value": "hsv(175, 55%, 88%)",
    "h": 175,
    "s": 55,
    "v": 88
    },
    "name": {
    "value": "Aquamarine Blue",
    "closest_named_hex": "#71D9E2",
    "exact_match_name": false,
    "distance": 540
    },
    "cmyk": {
    "fraction": {
    "c": 0.5535714285714286,
    "m": 0,
    "y": 0.04464285714285711,
    "k": 0.1215686274509804
    },
    "value": "cmyk(55, 0, 4, 12)",
    "c": 55,
    "m": 0,
    "y": 4,
    "k": 12
    },
    "XYZ": {
    "fraction": {
    "X": 0.6273309803921568,
    "Y": 0.7722180392156862,
    "Z": 0.9099521568627451
    },
    "value": "XYZ(63, 77, 91)",
    "X": 63,
    "Y": 77,
    "Z": 91
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=64E0D6",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=64E0D6"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=64E0D6"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#69E3D9",
    "clean": "69E3D9"
    },
    "rgb": {
    "fraction": {
    "r": 0.4117647058823529,
    "g": 0.8901960784313725,
    "b": 0.8509803921568627
    },
    "r": 105,
    "g": 227,
    "b": 217,
    "value": "rgb(105, 227, 217)"
    },
    "hsl": {
    "fraction": {
    "h": 0.48633879781420764,
    "s": 0.6853932584269662,
    "l": 0.6509803921568627
    },
    "h": 175,
    "s": 69,
    "l": 65,
    "value": "hsl(175, 69%, 65%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.48633879781420764,
    "s": 0.5374449339207048,
    "v": 0.8901960784313725
    },
    "value": "hsv(175, 54%, 89%)",
    "h": 175,
    "s": 54,
    "v": 89
    },
    "name": {
    "value": "Aquamarine Blue",
    "closest_named_hex": "#71D9E2",
    "exact_match_name": false,
    "distance": 421
    },
    "cmyk": {
    "fraction": {
    "c": 0.5374449339207048,
    "m": 0,
    "y": 0.044052863436123316,
    "k": 0.1098039215686275
    },
    "value": "cmyk(54, 0, 4, 11)",
    "c": 54,
    "m": 0,
    "y": 4,
    "k": 11
    },
    "XYZ": {
    "fraction": {
    "X": 0.6417478431372547,
    "Y": 0.7856501960784312,
    "Z": 0.9229152941176471
    },
    "value": "XYZ(64, 79, 92)",
    "X": 64,
    "Y": 79,
    "Z": 92
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=69E3D9",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=69E3D9"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=69E3D9"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#6FE6DC",
    "clean": "6FE6DC"
    },
    "rgb": {
    "fraction": {
    "r": 0.43529411764705883,
    "g": 0.9019607843137255,
    "b": 0.8627450980392157
    },
    "r": 111,
    "g": 230,
    "b": 220,
    "value": "rgb(111, 230, 220)"
    },
    "hsl": {
    "fraction": {
    "h": 0.4859943977591036,
    "s": 0.7041420118343195,
    "l": 0.6686274509803922
    },
    "h": 175,
    "s": 70,
    "l": 67,
    "value": "hsl(175, 70%, 67%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.4859943977591036,
    "s": 0.5173913043478261,
    "v": 0.9019607843137255
    },
    "value": "hsv(175, 52%, 90%)",
    "h": 175,
    "s": 52,
    "v": 90
    },
    "name": {
    "value": "Turquoise Blue",
    "closest_named_hex": "#6CDAE7",
    "exact_match_name": false,
    "distance": 436
    },
    "cmyk": {
    "fraction": {
    "c": 0.5173913043478261,
    "m": 0,
    "y": 0.04347826086956519,
    "k": 0.0980392156862745
    },
    "value": "cmyk(52, 0, 4, 10)",
    "c": 52,
    "m": 0,
    "y": 4,
    "k": 10
    },
    "XYZ": {
    "fraction": {
    "X": 0.6577819607843137,
    "Y": 0.7999160784313725,
    "Z": 0.9359541176470589
    },
    "value": "XYZ(66, 80, 94)",
    "X": 66,
    "Y": 80,
    "Z": 94
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=6FE6DC",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=6FE6DC"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=6FE6DC"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#EBD77C",
    "clean": "EBD77C"
    },
    "rgb": {
    "fraction": {
    "r": 0.9215686274509803,
    "g": 0.8431372549019608,
    "b": 0.48627450980392156
    },
    "r": 235,
    "g": 215,
    "b": 124,
    "value": "rgb(235, 215, 124)"
    },
    "hsl": {
    "fraction": {
    "h": 0.1366366366366366,
    "s": 0.7350993377483441,
    "l": 0.7039215686274509
    },
    "h": 49,
    "s": 74,
    "l": 70,
    "value": "hsl(49, 74%, 70%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.1366366366366366,
    "s": 0.47234042553191485,
    "v": 0.9215686274509803
    },
    "value": "hsv(49, 47%, 92%)",
    "h": 49,
    "s": 47,
    "v": 92
    },
    "name": {
    "value": "Flax",
    "closest_named_hex": "#EEDC82",
    "exact_match_name": false,
    "distance": 194
    },
    "cmyk": {
    "fraction": {
    "c": 0,
    "m": 0.08510638297872335,
    "y": 0.4723404255319148,
    "k": 0.07843137254901966
    },
    "value": "cmyk(0, 9, 47, 8)",
    "c": 0,
    "m": 9,
    "y": 47,
    "k": 8
    },
    "XYZ": {
    "fraction": {
    "X": 0.7693333333333333,
    "Y": 0.834046274509804,
    "Z": 0.5804921568627451
    },
    "value": "XYZ(77, 83, 58)",
    "X": 77,
    "Y": 83,
    "Z": 58
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=EBD77C",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=EBD77C"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=EBD77C"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#ECE87D",
    "clean": "ECE87D"
    },
    "rgb": {
    "fraction": {
    "r": 0.9254901960784314,
    "g": 0.9098039215686274,
    "b": 0.49019607843137253
    },
    "r": 236,
    "g": 232,
    "b": 125,
    "value": "rgb(236, 232, 125)"
    },
    "hsl": {
    "fraction": {
    "h": 0.16066066066066054,
    "s": 0.7449664429530204,
    "l": 0.707843137254902
    },
    "h": 58,
    "s": 74,
    "l": 71,
    "value": "hsl(58, 74%, 71%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.16066066066066054,
    "s": 0.4703389830508475,
    "v": 0.9254901960784314
    },
    "value": "hsv(58, 47%, 93%)",
    "h": 58,
    "s": 47,
    "v": 93
    },
    "name": {
    "value": "Flax",
    "closest_named_hex": "#EEDC82",
    "exact_match_name": false,
    "distance": 287
    },
    "cmyk": {
    "fraction": {
    "c": 0,
    "m": 0.01694915254237294,
    "y": 0.4703389830508474,
    "k": 0.07450980392156858
    },
    "value": "cmyk(0, 2, 47, 7)",
    "c": 0,
    "m": 2,
    "y": 47,
    "k": 7
    },
    "XYZ": {
    "fraction": {
    "X": 0.7954984313725489,
    "Y": 0.8828431372549019,
    "Z": 0.5922419607843137
    },
    "value": "XYZ(80, 88, 59)",
    "X": 80,
    "Y": 88,
    "Z": 59
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=ECE87D",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=ECE87D"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=ECE87D"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#DFEC7F",
    "clean": "DFEC7F"
    },
    "rgb": {
    "fraction": {
    "r": 0.8745098039215686,
    "g": 0.9254901960784314,
    "b": 0.4980392156862745
    },
    "r": 223,
    "g": 236,
    "b": 127,
    "value": "rgb(223, 236, 127)"
    },
    "hsl": {
    "fraction": {
    "h": 0.18654434250764518,
    "s": 0.7414965986394559,
    "l": 0.711764705882353
    },
    "h": 67,
    "s": 74,
    "l": 71,
    "value": "hsl(67, 74%, 71%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.18654434250764518,
    "s": 0.461864406779661,
    "v": 0.9254901960784314
    },
    "value": "hsv(67, 46%, 93%)",
    "h": 67,
    "s": 46,
    "v": 93
    },
    "name": {
    "value": "Manz",
    "closest_named_hex": "#EEEF78",
    "exact_match_name": false,
    "distance": 583
    },
    "cmyk": {
    "fraction": {
    "c": 0.055084745762711905,
    "m": 0,
    "y": 0.461864406779661,
    "k": 0.07450980392156858
    },
    "value": "cmyk(6, 0, 46, 7)",
    "c": 6,
    "m": 0,
    "y": 46,
    "k": 7
    },
    "XYZ": {
    "fraction": {
    "X": 0.7814992156862746,
    "Y": 0.8837898039215687,
    "Z": 0.6005827450980392
    },
    "value": "XYZ(78, 88, 60)",
    "X": 78,
    "Y": 88,
    "Z": 60
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=DFEC7F",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=DFEC7F"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=DFEC7F"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#D0ED80",
    "clean": "D0ED80"
    },
    "rgb": {
    "fraction": {
    "r": 0.8156862745098039,
    "g": 0.9294117647058824,
    "b": 0.5019607843137255
    },
    "r": 208,
    "g": 237,
    "b": 128,
    "value": "rgb(208, 237, 128)"
    },
    "hsl": {
    "fraction": {
    "h": 0.21100917431192645,
    "s": 0.7517241379310345,
    "l": 0.7156862745098039
    },
    "h": 76,
    "s": 75,
    "l": 72,
    "value": "hsl(76, 75%, 72%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.21100917431192645,
    "s": 0.45991561181434604,
    "v": 0.9294117647058824
    },
    "value": "hsv(76, 46%, 93%)",
    "h": 76,
    "s": 46,
    "v": 93
    },
    "name": {
    "value": "Sulu",
    "closest_named_hex": "#C1F07C",
    "exact_match_name": false,
    "distance": 564
    },
    "cmyk": {
    "fraction": {
    "c": 0.12236286919831228,
    "m": 0,
    "y": 0.45991561181434604,
    "k": 0.07058823529411762
    },
    "value": "cmyk(12, 0, 46, 7)",
    "c": 12,
    "m": 0,
    "y": 46,
    "k": 7
    },
    "XYZ": {
    "fraction": {
    "X": 0.759350588235294,
    "Y": 0.8743717647058824,
    "Z": 0.6036423529411765
    },
    "value": "XYZ(76, 87, 60)",
    "X": 76,
    "Y": 87,
    "Z": 60
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=D0ED80",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=D0ED80"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=D0ED80"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#C0ED81",
    "clean": "C0ED81"
    },
    "rgb": {
    "fraction": {
    "r": 0.7529411764705882,
    "g": 0.9294117647058824,
    "b": 0.5058823529411764
    },
    "r": 192,
    "g": 237,
    "b": 129,
    "value": "rgb(192, 237, 129)"
    },
    "hsl": {
    "fraction": {
    "h": 0.23611111111111094,
    "s": 0.7500000000000001,
    "l": 0.7176470588235294
    },
    "h": 85,
    "s": 75,
    "l": 72,
    "value": "hsl(85, 75%, 72%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.23611111111111094,
    "s": 0.4556962025316456,
    "v": 0.9294117647058824
    },
    "value": "hsv(85, 46%, 93%)",
    "h": 85,
    "s": 46,
    "v": 93
    },
    "name": {
    "value": "Sulu",
    "closest_named_hex": "#C1F07C",
    "exact_match_name": false,
    "distance": 281
    },
    "cmyk": {
    "fraction": {
    "c": 0.18987341772151903,
    "m": 0,
    "y": 0.4556962025316456,
    "k": 0.07058823529411762
    },
    "value": "cmyk(19, 0, 46, 7)",
    "c": 19,
    "m": 0,
    "y": 46,
    "k": 7
    },
    "XYZ": {
    "fraction": {
    "X": 0.7341823529411764,
    "Y": 0.8613152941176471,
    "Z": 0.6061588235294117
    },
    "value": "XYZ(73, 86, 61)",
    "X": 73,
    "Y": 86,
    "Z": 61
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=C0ED81",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=C0ED81"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=C0ED81"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#B1EE82",
    "clean": "B1EE82"
    },
    "rgb": {
    "fraction": {
    "r": 0.6941176470588235,
    "g": 0.9333333333333333,
    "b": 0.5098039215686274
    },
    "r": 177,
    "g": 238,
    "b": 130,
    "value": "rgb(177, 238, 130)"
    },
    "hsl": {
    "fraction": {
    "h": 0.2608024691358024,
    "s": 0.7605633802816902,
    "l": 0.7215686274509804
    },
    "h": 94,
    "s": 76,
    "l": 72,
    "value": "hsl(94, 76%, 72%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.2608024691358024,
    "s": 0.45378151260504207,
    "v": 0.9333333333333333
    },
    "value": "hsv(94, 45%, 93%)",
    "h": 94,
    "s": 45,
    "v": 93
    },
    "name": {
    "value": "Sulu",
    "closest_named_hex": "#C1F07C",
    "exact_match_name": false,
    "distance": 564
    },
    "cmyk": {
    "fraction": {
    "c": 0.2563025210084034,
    "m": 0,
    "y": 0.45378151260504207,
    "k": 0.06666666666666665
    },
    "value": "cmyk(26, 0, 45, 7)",
    "c": 26,
    "m": 0,
    "y": 45,
    "k": 7
    },
    "XYZ": {
    "fraction": {
    "X": 0.7120337254901961,
    "Y": 0.8518972549019608,
    "Z": 0.6092184313725489
    },
    "value": "XYZ(71, 85, 61)",
    "X": 71,
    "Y": 85,
    "Z": 61
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=B1EE82",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=B1EE82"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=B1EE82"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#A2EE84",
    "clean": "A2EE84"
    },
    "rgb": {
    "fraction": {
    "r": 0.6352941176470588,
    "g": 0.9333333333333333,
    "b": 0.5176470588235295
    },
    "r": 162,
    "g": 238,
    "b": 132,
    "value": "rgb(162, 238, 132)"
    },
    "hsl": {
    "fraction": {
    "h": 0.28616352201257855,
    "s": 0.7571428571428571,
    "l": 0.7254901960784315
    },
    "h": 103,
    "s": 76,
    "l": 73,
    "value": "hsl(103, 76%, 73%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.28616352201257855,
    "s": 0.4453781512605042,
    "v": 0.9333333333333333
    },
    "value": "hsv(103, 45%, 93%)",
    "h": 103,
    "s": 45,
    "v": 93
    },
    "name": {
    "value": "Sulu",
    "closest_named_hex": "#C1F07C",
    "exact_match_name": false,
    "distance": 1547
    },
    "cmyk": {
    "fraction": {
    "c": 0.319327731092437,
    "m": 0,
    "y": 0.4453781512605042,
    "k": 0.06666666666666665
    },
    "value": "cmyk(32, 0, 45, 7)",
    "c": 32,
    "m": 0,
    "y": 45,
    "k": 7
    },
    "XYZ": {
    "fraction": {
    "X": 0.6891905882352941,
    "Y": 0.8399576470588235,
    "Z": 0.6155380392156863
    },
    "value": "XYZ(69, 84, 62)",
    "X": 69,
    "Y": 84,
    "Z": 62
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=A2EE84",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=A2EE84"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=A2EE84"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#93EE85",
    "clean": "93EE85"
    },
    "rgb": {
    "fraction": {
    "r": 0.5764705882352941,
    "g": 0.9333333333333333,
    "b": 0.5215686274509804
    },
    "r": 147,
    "g": 238,
    "b": 133,
    "value": "rgb(147, 238, 133)"
    },
    "hsl": {
    "fraction": {
    "h": 0.3111111111111112,
    "s": 0.7553956834532375,
    "l": 0.7274509803921569
    },
    "h": 112,
    "s": 76,
    "l": 73,
    "value": "hsl(112, 76%, 73%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.3111111111111112,
    "s": 0.4411764705882353,
    "v": 0.9333333333333333
    },
    "value": "hsv(112, 44%, 93%)",
    "h": 112,
    "s": 44,
    "v": 93
    },
    "name": {
    "value": "Sulu",
    "closest_named_hex": "#C1F07C",
    "exact_match_name": false,
    "distance": 3219
    },
    "cmyk": {
    "fraction": {
    "c": 0.3823529411764707,
    "m": 0,
    "y": 0.4411764705882353,
    "k": 0.06666666666666665
    },
    "value": "cmyk(38, 0, 44, 7)",
    "c": 38,
    "m": 0,
    "y": 44,
    "k": 7
    },
    "XYZ": {
    "fraction": {
    "X": 0.6656396078431372,
    "Y": 0.8277349019607844,
    "Z": 0.6181301960784314
    },
    "value": "XYZ(67, 83, 62)",
    "X": 67,
    "Y": 83,
    "Z": 62
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=93EE85",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=93EE85"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=93EE85"
    }
    },
    "_embedded": {}
    },
    {
    "hex": {
    "value": "#86EF88",
    "clean": "86EF88"
    },
    "rgb": {
    "fraction": {
    "r": 0.5254901960784314,
    "g": 0.9372549019607843,
    "b": 0.5333333333333333
    },
    "r": 134,
    "g": 239,
    "b": 136,
    "value": "rgb(134, 239, 136)"
    },
    "hsl": {
    "fraction": {
    "h": 0.33650793650793653,
    "s": 0.7664233576642335,
    "l": 0.7313725490196079
    },
    "h": 121,
    "s": 77,
    "l": 73,
    "value": "hsl(121, 77%, 73%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.33650793650793653,
    "s": 0.4393305439330544,
    "v": 0.9372549019607843
    },
    "value": "hsv(121, 44%, 94%)",
    "h": 121,
    "s": 44,
    "v": 94
    },
    "name": {
    "value": "Pastel Green",
    "closest_named_hex": "#77DD77",
    "exact_match_name": false,
    "distance": 4878
    },
    "cmyk": {
    "fraction": {
    "c": 0.4393305439330544,
    "m": 0,
    "y": 0.4309623430962343,
    "k": 0.06274509803921569
    },
    "value": "cmyk(44, 0, 43, 6)",
    "c": 44,
    "m": 0,
    "y": 43,
    "k": 6
    },
    "XYZ": {
    "fraction": {
    "X": 0.6481411764705882,
    "Y": 0.8205505882352941,
    "Z": 0.6287960784313725
    },
    "value": "XYZ(65, 82, 63)",
    "X": 65,
    "Y": 82,
    "Z": 63
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=86EF88",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=86EF88"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=86EF88"
    }
    },
    "_embedded": {}
    }
    ],
    "seed": {
    "hex": {
    "value": "#EC7E87",
    "clean": "EC7E87"
    },
    "rgb": {
    "fraction": {
    "r": 0.9254901960784314,
    "g": 0.49411764705882355,
    "b": 0.5294117647058824
    },
    "r": 236,
    "g": 126,
    "b": 135,
    "value": "rgb(236, 126, 135)"
    },
    "hsl": {
    "fraction": {
    "h": 0.9863636363636362,
    "s": 0.7432432432432433,
    "l": 0.7098039215686275
    },
    "h": 355,
    "s": 74,
    "l": 71,
    "value": "hsl(355, 74%, 71%)"
    },
    "hsv": {
    "fraction": {
    "h": 0.9863636363636362,
    "s": 0.4661016949152542,
    "v": 0.9254901960784314
    },
    "value": "hsv(355, 47%, 93%)",
    "h": 355,
    "s": 47,
    "v": 93
    },
    "name": {
    "value": "Apricot",
    "closest_named_hex": "#EB9373",
    "exact_match_name": false,
    "distance": 1314
    },
    "cmyk": {
    "fraction": {
    "c": 0,
    "m": 0.4661016949152542,
    "y": 0.4279661016949153,
    "k": 0.07450980392156858
    },
    "value": "cmyk(0, 47, 43, 7)",
    "c": 0,
    "m": 47,
    "y": 43,
    "k": 7
    },
    "XYZ": {
    "fraction": {
    "X": 0.6539274509803922,
    "Y": 0.5883756862745098,
    "Z": 0.5799666666666666
    },
    "value": "XYZ(65, 59, 58)",
    "X": 65,
    "Y": 59,
    "Z": 58
    },
    "image": {
    "bare": "http://www.thecolorapi.com/id?format=svg&named=false&hex=EC7E87",
    "named": "http://www.thecolorapi.com/id?format=svg&hex=EC7E87"
    },
    "contrast": {
    "value": "#000000"
    },
    "_links": {
    "self": {
    "href": "/id?hex=EC7E87"
    }
    },
    "_embedded": {}
    },
    "image": {
    "bare": "http://www.thecolorapi.com/scheme?format=svg&named=false&hex=EC7E87&mode=analogic-complement&count=15",
    "named": "http://www.thecolorapi.com/scheme?format=svg&hex=EC7E87&mode=analogic-complement&count=15"
    },
    "_links": {
    "self": "/scheme?hex=EC7E87&mode=analogic-complement&count=15",
    "schemes": {
    "monochrome": "/scheme?hex=EC7E87&mode=monochrome&count=15",
    "monochrome-dark": "/scheme?hex=EC7E87&mode=monochrome-dark&count=15",
    "monochrome-light": "/scheme?hex=EC7E87&mode=monochrome-light&count=15",
    "analogic": "/scheme?hex=EC7E87&mode=analogic&count=15",
    "complement": "/scheme?hex=EC7E87&mode=complement&count=15",
    "analogic-complement": "/scheme?hex=EC7E87&mode=analogic-complement&count=15",
    "triad": "/scheme?hex=EC7E87&mode=triad&count=15",
    "quad": "/scheme?hex=EC7E87&mode=quad&count=15"
    }
    },
    "_embedded": {}
    }